// extracted by mini-css-extract-plugin
module.exports = {"delivery-type-title":"ProductsPaymentUI__delivery-type-title___7c9f6"};